import * as React from 'react';
import {useState} from 'react';
import {AssetSearchRequest, FieldFacets, Navigation} from "../../api";
import FilterArea from "./FilterArea";
import NavigationArea from "./NavigationArea";
import iconRight from "../../assets/icons/arrow-right.svg";
import iconLeft from "../../assets/icons/arrow-left.svg";
import {useSearchParams} from "react-router-dom";
import SearchForm from "./SearchForm";

interface ISidebarLeft {
    navigation: Navigation | undefined;
    facets: Array<FieldFacets>;
    request: AssetSearchRequest;
}

export const SidebarLeft: React.FC<ISidebarLeft> = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [collapsed, setCollapsed] = useState<boolean>(false);
    const [resetCount, setResetCount] = React.useState<number>(0);

    function toggleSidebar() {
        setCollapsed(!collapsed);
    }

    function resetSearch() {
        setSearchParams((values) => {
            values.delete("query");
            values.delete("filters");
            values.delete("navigation");
            return values;
        });
        setResetCount(resetCount + 1);
    }

    function hasNoSearch(): boolean {
        return (
            (searchParams.get("filters") === "" ||
                searchParams.get("filters") === null) &&
            (searchParams.get("query") === "" ||
                searchParams.get("query") === null) &&
            (searchParams.get("navigation") === "" ||
                searchParams.get("navigation") === null)
        );
    }

    const renderNavigationArea = () => {
        if (props.navigation) {
            return (<>
                        <hr/>
                        <NavigationArea navigation={props.navigation}/>
                    </>)
        }
        return ""
    };

    const renderFilterArea = () => {
        if (props.facets && props.facets.length > 0) {
            return (<>
                        <FilterArea facets={props.facets}/>
                        <hr/>
                    </>)
        }
        return ""
    };

    return (
        <div className={"sidebar" + (collapsed ? " sidebar-collapsed" : "")}>

            <div className="mb-2" role="button" onClick={toggleSidebar}>
                <div className={collapsed ? "" : "d-none"}>
                    <img className="icon icon-sm" src={iconRight} title="Show sidebar" alt="Show sidebar"/>
                </div>
                <div className={"align-items-center" + (collapsed ? " d-none" : " d-flex")}>
                    <img className="icon icon-sm" src={iconLeft} title="Hide sidebar" alt=""/>
                    <div><small>Hide Sidebar</small></div>
                </div>
            </div>

            <div className={collapsed ? "d-none" : ""}>
                <button
                    type="button"
                    className="btn btn-primary w-100 mb-2"
                    onClick={resetSearch}
                    disabled={hasNoSearch()}>
                    Reset Search
                </button>
                {renderFilterArea()}
                <SearchForm resetCount={resetCount}/>
                {renderNavigationArea()}
            </div>

        </div>
    );
};
export default SidebarLeft;
